import React from "react";
import { useTranslation } from "react-i18next";
import { TextareaAutosize } from "@mui/material";

export interface ReportingDescriptionProps {
  text: string;
  onChange: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
}

export function ReportingDescription(props: ReportingDescriptionProps) {
  const { t } = useTranslation();
  const { text, onChange } = props;
  return (
    <>
      <p>{t("reports.optionalDescription")}</p>
      <TextareaAutosize value={text} onChange={onChange} minRows={2} style={{ width: "100%" }} />
    </>
  );
}
